import React from 'react';

const EternalBenefitSection = () => {
  return (
    <section className="eternal-benefit-section">
      <div className="section-background">
        <img
          src="https://i.postimg.cc/kXWnHs5f/krishna.jpg"
          alt="Lord Krishna"
          className="background-image"
        />
        <div className="section-overlay">
          <div className="container">
            <h2 className="section-heading">The Eternal Benefit of Giving</h2>
            
            <div className="quotes-container">
              <div className="quote-card">
                <blockquote>
                  <p>
                    "If one offers Me with love and devotion a leaf, a flower, a fruit or water, I will accept it."
                  </p>
                  <footer>
                    <cite>Bhagavad Gita 9.26</cite>
                  </footer>
                </blockquote>
              </div>
              
              <div className="quote-card">
                <blockquote>
                  <p>
                    "What the devotee actually offers the Lord is not needed by the Lord, for He is self-sufficient. If the devotee offers something to the Lord, it acts for his own interest because whatever a devotee offers the Lord comes back in a quantity a million times greater than what was offered."
                  </p>
                  <footer>
                    <cite>Krishna Book, Chapter 81</cite>
                  </footer>
                </blockquote>
              </div>
              
              <div className="quote-card">
                <blockquote>
                  <p>
                    "By fully concentrating on distributing books for Krsna, one is fully absorbed in Krsna. This is samadhi."
                  </p>
                  <footer>
                    <cite>Srimad Bhagavatam 10.2.37, purport</cite>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EternalBenefitSection;